import { useState } from "react";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { formatApiError } from "@/lib/api";
import { Action, Panel, PanelHeader } from "./ui";

const INPUT =
  "mt-2 w-full rounded-xl border border-border bg-white px-3.5 py-3 text-[15px] text-ink-800 focus:border-sage-600 focus:outline-none focus:ring-2 focus:ring-sage-600/15";

/** Primeiro acesso: nenhuma outra página do Portal abre antes da troca da senha temporária. */
export default function ForcePasswordChange() {
  const { api, adoptSession, logout } = useAuth();
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.post("/auth/first-access-password", {
        new_password: password,
        new_password_confirmation: confirmation,
      });
      toast.success("Senha definida. Bem-vindo(a) ao Portal Erimus.");
      adoptSession(data);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
    setSaving(false);
  };

  return (
    <div data-testid="force-password-page" className="min-h-screen bg-bone px-6 py-16">
      <div className="mx-auto max-w-lg">
        <Panel className="space-y-5">
          <PanelHeader
            label="Primeiro acesso"
            title="Defina sua senha"
            hint="Sua senha atual é temporária. Crie uma nova senha para liberar o acesso ao Portal."
          />
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="block text-[13px] font-semibold uppercase tracking-[0.08em] text-ink-600">
                Nova senha
              </label>
              <input
                data-testid="force-password-new"
                type="password"
                autoComplete="new-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className={INPUT}
                required
              />
            </div>
            <div>
              <label className="block text-[13px] font-semibold uppercase tracking-[0.08em] text-ink-600">
                Confirmar nova senha
              </label>
              <input
                data-testid="force-password-confirm"
                type="password"
                autoComplete="new-password"
                value={confirmation}
                onChange={(e) => setConfirmation(e.target.value)}
                className={INPUT}
                required
              />
            </div>
            <p className="text-[13px] text-ink-500">Mínimo de 8 caracteres, combinando letras e números.</p>
            <div className="flex flex-wrap gap-2.5">
              <Action icon={KeyRound} type="submit" data-testid="force-password-submit" disabled={saving}>
                {saving ? "Salvando…" : "Salvar e entrar"}
              </Action>
              <Action variant="secondary" data-testid="force-password-logout" onClick={logout}>
                Sair
              </Action>
            </div>
          </form>
        </Panel>
      </div>
    </div>
  );
}
